import React from 'react';
import {useStyles} from './styles';
import {Box, Breadcrumbs, Paper} from '@material-ui/core';

/**
 * function to render application level breadcrumb container
 * @returns {JSX.Element}
 * @constructor
 */
const AppBreadCrumb = ({children}) => {
  const classes = useStyles();

  return (
    <Box className={classes.breadcrumbsContainer} component={Paper} p={1}>
      <Breadcrumbs>
        {children}
      </Breadcrumbs>
    </Box>
  );
};

export default AppBreadCrumb;
